import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "login-page" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = { class: "admin-white-bg admin-custom-row" }
const _hoisted_5 = { class: "admin-login-left" }
const _hoisted_6 = { class: "admin-login-form" }
const _hoisted_7 = { class: "login-input" }
const _hoisted_8 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_9 = { class: "login-input" }
const _hoisted_10 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_11 = { class: "login-input-row" }
const _hoisted_12 = { class: "remember-me-box" }
const _hoisted_13 = { for: "loginRmrInput" }
const _hoisted_14 = { class: "right-txt-link" }
const _hoisted_15 = {
  id: "loginSubmitBtn",
  class: "primary-btn",
  type: "submit"
}
const _hoisted_16 = { class: "admin-login-right" }
const _hoisted_17 = { class: "admin-login-right-in" }
const _hoisted_18 = { class: "admin-site-footer" }
const _hoisted_19 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "admin-logo" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Logo"
              })
            ], -1)),
            _createElementVNode("h1", null, _toDisplayString(_ctx.constants.LOGIN_TEXT), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                id: "forgotLoginForm",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "loginEmailInput",
                    placeholder: "Enter Email address",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ]),
                  (!_ctx.email||_ctx.errorMsg==='Please enter a valid Email')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMsg), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.PASSWORD_LABEL), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    id: "loginPwtInput",
                    placeholder: "Password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.password]
                  ]),
                  (!_ctx.password||_ctx.errorMsg==='Please enter a valid Password')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMsg), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      name: "cssCheckbox",
                      id: "loginRmrInput",
                      type: "checkbox",
                      class: "css-checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.rememberMe]
                    ]),
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.constants.REMEMBER_ME_LABEL), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("a", {
                      id: "loginFpLink",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.push('/authority/forgot-password')), ["prevent"]))
                    }, _toDisplayString(_ctx.constants.FORGOT_PASSWORD_LINK), 1)
                  ])
                ]),
                _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.constants.LOGIN_BUTTON), 1)
              ], 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, _toDisplayString(_ctx.constants.WELCOME_TO_TEXT), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.constants.LMD_CONSULTING_TEXT), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.constants.LOGIN_TO_ACCESS_DASHBOARD_TEXT), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ])
  ]))
}